import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { PreserveState } from "./secure-storage";
import { campaignsService } from "../api/campaigns.api";
import { CampaignModel } from "../models/Campaign";
import dayjs from "dayjs";

const name = "campaigns";

@Module({
  store,
  name,
  dynamic: true,
  namespaced: true,
  preserveState: PreserveState(name)
})
class CampaignModule extends VuexModule {
  public campaigns: CampaignModel[] = [];

  @Mutation
  SET_DATA(data: CampaignModel[]) {
    this.campaigns = data;
  }

  @Action({ commit: "SET_DATA" })
  public async getCampaigns() {
    const response = await campaignsService.getCampaigns();
    const result = response.data.map((item: any) => ({ ...item, loadDate: dayjs().toISOString() }));
    return result;
  }
}

export const campaignsStore = getModule(CampaignModule);
